export const objectIsEmpty = obj => {
  for (let key in obj) {
    if (obj[key] != null && obj[key] !== '') {
      return false;
    }
  }
  return true;
};

export const objectHasAllValuesZero = obj => {
  for (let key in obj) {
    if (obj[key] != null && obj[key] !== 0) {
      return false;
    }
  }
  return true;
};

export const setObjectPropsToZero = obj => {
  for (let key in obj) {
    obj[key] = 0;
  }
};

export const createMarkup = content => {
  return {
    __html: content
      .replace(' www.', ' https://www.')
      .replace(
        /(\b(https?|ftp|file):\/\/[\-A-Z0-9+&@#\/%?=~_|!:,.;]*[\-A-Z09+&@#\/%=~_|])/gim,
        '<a href="$1" target="_blank">$1</a>'
      ),
  };
};
